var _rect, _path, _path2, _path3, _path4, _rect2, _g, _ellipse, _path5, _rect3, _path6, _path7, _path8, _path9, _rect4, _g2, _path0, _ellipse2, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 75,
    viewBox: "0 0 248 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16469,
    y: 6.48109,
    width: 106.966,
    height: 67.4013,
    rx: 7.265,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 25.212V16.0076C15.8125 13.1729 18.1105 10.875 20.9451 10.875H30.3846",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 54.5907V63.7951C15.8125 66.6298 18.1105 68.9277 20.9451 68.9277H30.3846",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.375 25.212V16.0076C93.375 13.1729 91.077 10.875 88.2424 10.875H78.8029",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.375 54.5907V63.7951C93.375 66.6298 91.077 68.9277 88.2424 68.9277H78.8029",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5171_134008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 64,
    height: 46
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.765,
    y: 18.2845,
    width: 61.601,
    height: 43.2324,
    rx: 5.535,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5171_134008)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.9062,
    y: 19.0195,
    width: 65.5385,
    height: 43.549,
    rx: 4.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2886 54.5295H45.9137C47.107 54.5295 48.0778 53.5211 48.0778 52.2822V40.4739C48.0778 39.235 47.1069 38.2266 45.9137 38.2266H32.2886C31.0959 38.2266 30.125 39.235 30.125 40.4739V52.2822C30.125 53.5211 31.0959 54.5295 32.2886 54.5295ZM43.0238 53.3554H35.1791V52.5545C35.1791 51.1115 35.9106 49.8498 37.0031 49.1261C37.6204 49.5218 38.3371 49.753 39.1039 49.753C39.8691 49.753 40.5841 49.5223 41.2004 49.1273C42.2924 49.8511 43.0238 51.1121 43.0238 52.5547V53.3554ZM36.0765 45.227C36.0765 43.3753 37.4348 41.8693 39.1039 41.8693C40.7702 41.8693 42.1262 43.3753 42.1262 45.227C42.1262 47.0753 40.7702 48.5789 39.1039 48.5789C37.4349 48.5789 36.0765 47.0752 36.0765 45.227ZM31.2554 40.4739C31.2554 39.8822 31.719 39.4007 32.2886 39.4007H45.9137C46.4838 39.4007 46.9475 39.8822 46.9475 40.4739V52.2822C46.9475 52.8739 46.4839 53.3554 45.9137 53.3554H44.1541V52.5545C44.1541 50.8303 43.3426 49.3066 42.1026 48.3494C42.8157 47.5364 43.2566 46.4377 43.2566 45.2269C43.2566 42.728 41.3939 40.6951 39.1039 40.6951C36.8111 40.6951 34.9461 42.7279 34.9461 45.2269C34.9461 46.4361 35.3867 47.5334 36.0988 48.3462C34.858 49.3028 34.0487 50.8297 34.0487 52.5545V53.3554H32.2886C31.719 53.3554 31.2554 52.8739 31.2554 52.2822V40.4739Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7913 38.6172H54.2183C53.778 38.6172 53.4219 38.9581 53.4219 39.3792C53.4219 39.8005 53.7782 40.1413 54.2183 40.1413H75.7913C76.2315 40.1413 76.5877 39.8003 76.5877 39.3792C76.5877 38.9581 76.2315 38.6172 75.7913 38.6172Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7913 42.2754H54.2183C53.778 42.2754 53.4219 42.6163 53.4219 43.0374C53.4219 43.4587 53.7782 43.7995 54.2183 43.7995H75.7913C76.2315 43.7995 76.5877 43.4585 76.5877 43.0374C76.5877 42.6163 76.2315 42.2754 75.7913 42.2754Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8358 48.3711H54.0079C53.6839 48.3711 53.4219 48.712 53.4219 49.1331C53.4219 49.5544 53.6841 49.8952 54.0079 49.8952H80.8358C81.1598 49.8952 81.4219 49.5542 81.4219 49.1331C81.4219 48.7118 81.1598 48.3711 80.8358 48.3711Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8358 54.4668H54.0079C53.6839 54.4668 53.4219 54.8077 53.4219 55.2288C53.4219 55.6501 53.6841 55.9909 54.0079 55.9909H80.8358C81.1598 55.9909 81.4219 55.6499 81.4219 55.2288C81.4219 54.8076 81.1598 54.4668 80.8358 54.4668Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9156 14.9124C80.6434 15.1111 83.6968 15.4779 86.38 16.0374C87.7214 16.3172 88.9828 16.6483 90.0706 17.0351C91.149 17.4184 92.1018 17.8722 92.7932 18.4187C93.4823 18.9634 94.0176 19.6903 93.9866 20.6042C93.9565 21.49 93.3985 22.3024 92.5269 23.0477C90.7821 24.5399 87.2756 26.1936 81.4513 28.0646C70.1479 31.6957 57.3308 31.9625 45.7485 30.7828C34.1604 29.6024 23.7527 26.9683 17.2348 24.7543C16.0121 24.339 15.0702 23.3966 14.6086 22.2133C13.5812 19.578 15.252 16.677 18.0422 16.2521L40.5423 12.8275C40.925 12.7693 41.3128 12.7508 41.6994 12.7736L77.9156 14.9124Z",
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3994 23.1982C39.4553 23.1984 41.8925 25.7497 41.8926 28.8467C41.8926 31.9437 39.4553 34.495 36.3994 34.4951C33.3434 34.4951 30.9053 31.9438 30.9053 28.8467C30.9053 25.7496 33.3435 23.1982 36.3994 23.1982Z",
    fill: "#51E1CE",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.765,
    y: 18.2845,
    width: 61.601,
    height: 43.2324,
    rx: 5.535,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.828,
    cy: 9.44754,
    rx: 7.52371,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.664 1.74219C107.051 1.74219 105.474 2.20405 104.133 3.06936C102.791 3.93468 101.746 5.16459 101.129 6.60356C100.511 8.04252 100.35 9.62592 100.665 11.1535C100.979 12.6811 101.756 14.0843 102.897 15.1857C104.037 16.287 105.491 17.037 107.073 17.3409C108.655 17.6447 110.295 17.4888 111.785 16.8927C113.276 16.2967 114.55 15.2873 115.446 13.9923C116.342 12.6973 116.82 11.1747 116.82 9.61719C116.82 7.52861 115.961 5.52557 114.431 4.04872C112.902 2.57187 110.827 1.74219 108.664 1.74219ZM107.499 12.762L104.586 9.94951L105.513 9.05469L107.499 10.9724L111.816 6.80469L112.746 7.69676L107.499 12.762Z",
    fill: "#00D492"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.719,
    y: 6.48109,
    width: 106.966,
    height: 67.4013,
    rx: 7.265,
    fill: "white",
    stroke: "#168374",
    strokeWidth: 1.47
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.367 25.212V16.0076C146.367 13.1729 148.665 10.875 151.5 10.875H160.939",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.367 54.5907V63.7951C146.367 66.6298 148.665 68.9277 151.5 68.9277H160.939",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.93 25.212V16.0076C223.93 13.1729 221.632 10.875 218.797 10.875H209.358",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.93 54.5907V63.7951C223.93 66.6298 221.632 68.9277 218.797 68.9277H209.358",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5171_134008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 17,
    width: 64,
    height: 46
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 154.32,
    y: 18.2845,
    width: 61.601,
    height: 43.2324,
    rx: 5.535,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5171_134008)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.461,
    y: 19.0195,
    width: 65.5385,
    height: 43.549,
    rx: 4.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.843 54.5295H176.468C177.662 54.5295 178.632 53.5211 178.632 52.2822V40.4739C178.632 39.235 177.662 38.2266 176.468 38.2266H162.843C161.651 38.2266 160.68 39.235 160.68 40.4739V52.2822C160.68 53.5211 161.651 54.5295 162.843 54.5295ZM173.578 53.3554H165.734V52.5545C165.734 51.1115 166.465 49.8498 167.558 49.1261C168.175 49.5218 168.892 49.753 169.659 49.753C170.424 49.753 171.139 49.5223 171.755 49.1273C172.847 49.8511 173.578 51.1121 173.578 52.5547V53.3554ZM166.631 45.227C166.631 43.3753 167.989 41.8693 169.659 41.8693C171.325 41.8693 172.681 43.3753 172.681 45.227C172.681 47.0753 171.325 48.5789 169.659 48.5789C167.99 48.5789 166.631 47.0752 166.631 45.227ZM161.81 40.4739C161.81 39.8822 162.274 39.4007 162.843 39.4007H176.468C177.038 39.4007 177.502 39.8822 177.502 40.4739V52.2822C177.502 52.8739 177.039 53.3554 176.468 53.3554H174.709V52.5545C174.709 50.8303 173.897 49.3066 172.657 48.3494C173.37 47.5364 173.811 46.4377 173.811 45.2269C173.811 42.728 171.949 40.6951 169.659 40.6951C167.366 40.6951 165.501 42.7279 165.501 45.2269C165.501 46.4361 165.941 47.5334 166.654 48.3462C165.413 49.3028 164.603 50.8297 164.603 52.5545V53.3554H162.843C162.274 53.3554 161.81 52.8739 161.81 52.2822V40.4739Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.041 38.6172H185.468C185.028 38.6172 184.672 38.9581 184.672 39.3792C184.672 39.8005 185.028 40.1413 185.468 40.1413H207.041C207.482 40.1413 207.838 39.8003 207.838 39.3792C207.838 38.9581 207.482 38.6172 207.041 38.6172Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.041 42.2754H185.468C185.028 42.2754 184.672 42.6163 184.672 43.0374C184.672 43.4587 185.028 43.7995 185.468 43.7995H207.041C207.482 43.7995 207.838 43.4585 207.838 43.0374C207.838 42.6163 207.482 42.2754 207.041 42.2754Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.086 48.3711H185.258C184.934 48.3711 184.672 48.712 184.672 49.1331C184.672 49.5544 184.934 49.8952 185.258 49.8952H212.086C212.41 49.8952 212.672 49.5542 212.672 49.1331C212.672 48.7118 212.41 48.3711 212.086 48.3711Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.086 54.4668H185.258C184.934 54.4668 184.672 54.8077 184.672 55.2288C184.672 55.6501 184.934 55.9909 185.258 55.9909H212.086C212.41 55.9909 212.672 55.6499 212.672 55.2288C212.672 54.8076 212.41 54.4668 212.086 54.4668Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.47 14.9124C211.198 15.1111 214.251 15.4779 216.935 16.0374C218.276 16.3172 219.537 16.6483 220.625 17.0351C221.704 17.4184 222.657 17.8722 223.348 18.4187C224.037 18.9634 224.572 19.6903 224.541 20.6042C224.511 21.49 223.953 22.3024 223.082 23.0477C221.337 24.5399 217.83 26.1936 212.006 28.0646C200.703 31.6957 187.885 31.9625 176.303 30.7828C164.715 29.6024 154.307 26.9683 147.789 24.7543C146.567 24.339 145.625 23.3966 145.163 22.2133C144.136 19.578 145.807 16.677 148.597 16.2521L171.097 12.8275C171.48 12.7693 171.867 12.7508 172.254 12.7736L208.47 14.9124Z",
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.954 23.1982C170.01 23.1984 172.447 25.7497 172.447 28.8467C172.447 31.9437 170.01 34.495 166.954 34.4951C163.898 34.4951 161.46 31.9438 161.46 28.8467C161.46 25.7496 163.898 23.1982 166.954 23.1982Z",
    fill: "#51E1CE",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.32,
    y: 18.2845,
    width: 61.601,
    height: 43.2324,
    rx: 5.535,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M191.066 5.74609H231.423C235.841 5.74609 239.423 9.32782 239.423 13.7461V66.6174C239.423 71.0357 235.841 74.6174 231.423 74.6174H162.492L191.066 5.74609Z",
    fill: "#263238",
    fillOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.601,
    cy: 10.023,
    rx: 5.40576,
    ry: 5.40576,
    fill: "#ECFDF5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M238.57 1.74219C234.183 1.74219 230.695 5.22969 230.695 9.61719C230.695 14.0047 234.183 17.4922 238.57 17.4922C242.958 17.4922 246.445 14.0047 246.445 9.61719C246.445 5.22969 242.958 1.74219 238.57 1.74219ZM241.608 13.5547L238.57 10.5172L235.533 13.5547L234.633 12.6547L237.67 9.61719L234.633 6.57969L235.533 5.67969L238.57 8.71719L241.608 5.67969L242.508 6.57969L239.47 9.61719L242.508 12.6547L241.608 13.5547Z",
    fill: "#FF6467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceId);
export default __webpack_public_path__ + "static/media/img-place-id.444953c9703e4799572bc9bb42771001.svg";
export { ForwardRef as ReactComponent };